function discountError(statusCode, code) { return Object.assign(new Error(code), { statusCode, code }); }
function assertDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(Date.parse(value)) || new Date(value).toISOString().slice(0, 10) !== value) throw discountError(400, 'DISCOUNT_DATE_INVALID');
  return value;
}
function assertPercent(value) {
  if (!Number.isInteger(value) || value < 0 || value > 10000) throw discountError(400, 'DISCOUNT_PERCENT_INVALID');
  return value;
}
function effectiveVersions(versions, idKey, date, startKey) {
  const selected = new Map();
  versions.forEach(version => {
    if (version[startKey] > date) return;
    const previous = selected.get(version[idKey]);
    if (!previous || version[startKey] > previous[startKey] || (version[startKey] === previous[startKey] && version.version > previous.version)) selected.set(version[idKey], version);
  });
  return Array.from(selected.values());
}
function applyDiscounts(items, grants = [], types = []) {
  const grantKey = grant => JSON.stringify([grant.clientId, grant.grantId]);
  const deletedIds = new Set(grants.filter(grant => grant.deletedAt).map(grantKey));
  const retainedGrants = grants.filter(grant => !deletedIds.has(grantKey(grant)));
  grants.forEach(grant => assertPercent(grant.percentBasisPoints));
  return items.map(item => {
    if (!Number.isSafeInteger(item.baseAmountCents) || item.baseAmountCents < 0) throw discountError(400, 'DISCOUNT_AMOUNT_INVALID');
    assertDate(item.date);
    const activeTypes = effectiveVersions(types, 'typeId', item.date, 'effectiveFrom');
    const candidates = item.eligibleForDiscount ? effectiveVersions(retainedGrants.filter(grant => grant.clientId === item.clientId), 'grantId', item.date, 'validFrom').filter(grant => {
      const type = activeTypes.find(candidate => candidate.typeId === grant.typeId);
      return type && (!type.endedFrom || item.date < type.endedFrom) && (!grant.endedFrom || item.date < grant.endedFrom) &&
        (!grant.validTo || item.date <= grant.validTo) && (grant.studentScope === 'all' || (grant.studentIds || []).includes(item.studentId));
    }).sort((a, b) => b.percentBasisPoints - a.percentBasisPoints || a.typeId.localeCompare(b.typeId) || a.grantId.localeCompare(b.grantId)) : [];
    const grant = candidates[0];
    const type = grant && activeTypes.find(candidate => candidate.typeId === grant.typeId);
    // Split the product to retain exact cent rounding without unsafe integer multiplication.
    const reduction = grant ? Math.floor(item.baseAmountCents / 10000) * grant.percentBasisPoints + Math.round(((item.baseAmountCents % 10000) * grant.percentBasisPoints) / 10000) : 0;
    return { ...item,
      finalAmountCents: item.baseAmountCents - reduction,
      discountAmountCents: reduction,
      appliedDiscount: grant ? { typeId: type.typeId,
        typeVersion: type.version,
        grantId: grant.grantId,
        grantVersion: grant.version,
        name: type.name,
        reason: grant.reason || '',
        percentBasisPoints: grant.percentBasisPoints,
        validFrom: grant.validFrom,
        validTo: grant.validTo || null } : null };
  });
}
function usedDiscountGrantIds(entries, operations) {
  const approvedEntries = [...entries, ...operations.filter(operation => operation.type === 'SETTLEMENT_APPROVAL')
    .flatMap(operation => [operation.result && operation.result.entry, operation.previousEntry])];
  return [...new Set(approvedEntries.filter(entry => entry && entry.type === 'MONTHLY_CHARGE' && entry.status !== 'DRAFT')
    .flatMap(entry => ((entry.snapshot && entry.snapshot.charged) || []).map(item => item.appliedDiscount && item.appliedDiscount.grantId)).filter(Boolean))];
}
module.exports = { applyDiscounts, assertDate, assertPercent, effectiveVersions, discountError, usedDiscountGrantIds };
